import React from 'react';

import { T8y } from 'ui';

export const Meta16 = () => {
  return (
    <div>
      <T8y as="h1" center bold mb2>
        16 Yard Skip
      </T8y>
      <T8y as="h2" center mb2>
        The Ultimate Solution for Bulk Waste
      </T8y>
      <T8y as="p" center mb3>
        Our 16-yard skip is the largest in our range, ideal for projects
        generating significant amounts of waste. It's the ultimate solution for
        efficient, large-scale waste management in commercial and industrial
        settings.
      </T8y>
      <T8y as="h3" center mb2>
        Ideal Scenarios for a 16 Yard Skip
      </T8y>
      <T8y as="p" center mb3>
        Major construction developments <br />
        Large industrial clearances <br />
        Community project waste disposal <br />
        Large-scale event cleanups <br />
      </T8y>
      <T8y as="h3" center mb2>
        Why a 16 Yard Skip is the Right Choice
      </T8y>
      <T8y as="p" center mb3>
        Maximum Capacity: Handles the largest volume of waste. <br />
        Cost and Time Efficient: Reduces the frequency of waste removal
        services. <br />
        Professional Grade: Suitable for commercial and industrial use. <br />
        Compliance: Meets waste management regulations for large projects.
        <br />
      </T8y>
      <T8y as="h4" center mb2>
        How to Hire a 16 Yard Skip
      </T8y>
      <T8y as="p" center mb5>
        Contact us to discuss your project's requirements. We'll provide expert
        advice and manage all aspects of the skip hire process, ensuring timely
        delivery and collection to keep your project on track.
      </T8y>
    </div>
  );
};
